module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"text":"Cервис видеособеседований с человеческим лицом"}}')
  delete Component.options._Ctor
}
